import { Reveal } from "@/components/Reveal";

export const PageHero = ({ eyebrow, title, tagline, subtitle, testid }) => (
  <section data-testid={testid} className="bg-[#0D3327]">
    <div className="mx-auto max-w-7xl px-4 py-20 sm:px-6 sm:py-24 lg:px-8">
      <Reveal>
        {eyebrow && (
          <p className="text-xs font-semibold uppercase tracking-[0.28em] text-[#E8F1EC]/50">{eyebrow}</p>
        )}
        <h1 className="mt-4 max-w-3xl font-serif text-4xl font-semibold leading-tight text-white sm:text-5xl">
          {title}
        </h1>
        {tagline && (
          <p className="mt-5 flex items-center gap-3 text-sm font-semibold uppercase tracking-[0.18em] text-[#E8F1EC]/80 sm:text-base">
            <span className="h-px w-8 shrink-0 bg-[#2E6B50]" />
            {tagline}
          </p>
        )}
        {subtitle && (
          <p className="mt-6 max-w-2xl text-base leading-relaxed text-white/70 sm:text-lg">{subtitle}</p>
        )}
      </Reveal>
    </div>
  </section>
);
